import PropTypes from 'prop-types';

import React from 'react';

import LoadingBtn from '../loadingBtn.jsx';

import {FormattedMessage} from 'react-intl';

class Popup extends React.Component {
  static defaultProps = {
    message: '',
    title: '',
    visible: false,
  };

  static propTypes = {
    message: PropTypes.string.isRequired,
    onAccept: PropTypes.func.isRequired,
    onDecline: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    visible: PropTypes.bool.isRequired,
  };

  state = {
    loading: false,
  };

  accept = () => {
    this.props.onAccept();
    this.setState({
      loading: true,
    });
  };

  render() {
    let output = <div />;

    if (this.props.visible) {
      output =
        <div className='modal' tabIndex='-1' role='dialog' style={{display: 'block'}}>
          <div className='modal-dialog'>
            <div className='modal-content modal-content-popup'>
              <div className='modal-header'>
                <button type='button' className='close' aria-label='Close' onClick={this.props.onDecline}>
                  <span aria-hidden='true'>&times;</span>
                </button>
                <h4 className='modal-title'>{this.props.title}</h4>
              </div>
              <div className='modal-body'>
                <p>{this.props.message}</p>
              </div>
              <div className='modal-footer'>
                <button type='button' className='btn btn-default' onClick={this.props.onDecline}><FormattedMessage id="general.no" /></button>
                <LoadingBtn type='button' className='btn btn-primary' onClick={this.accept} loading={this.state.loading}><FormattedMessage id="general.yes" /></LoadingBtn>
              </div>
            </div>
          </div>
        </div>
      ;
    }
    return output;
  }
}

export default Popup;
